// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import assignRadioData from 'components/SearchAndSelect/Sets/common/RadioField/RadioCode/helpers/assignRadioData'
import getInitialRadioLookupValues from 'components/SearchAndSelect/Sets/common/RadioField/RadioCode/helpers/getInitialRadioLookupValues'

const usePathDatabaseSearchRadioLookup = (sourceForm, lookupFormName) => {
  const dispatch = useDispatch()

  const assignRadio = useCallback(radio => {
    dispatch(assignRadioData(radio, sourceForm))
  }, [sourceForm])

  const getLookupTypeProps = useCallback(() => {
    const styles = {
      content: { width: 1000 },
    }

    const {
      initialValues,
      triggerSearchOnMount,
    } = dispatch(getInitialRadioLookupValues(sourceForm, lookupFormName))

    return {
      initialValues,
      styles,
      triggerSearchOnMount,
    }
  }, [sourceForm, lookupFormName])

  return {
    assignRadio,
    getLookupTypeProps,
  }
}

export default usePathDatabaseSearchRadioLookup
